export default function setInputsMask() {
    const phoneInputs = document.querySelectorAll('[data-phone-input]');

    if (phoneInputs.length < 1) return;
    
    phoneInputs.forEach(input => {
        input.addEventListener('input', (e) => {
            let value = e.target.value;

            // Remove tudo que não for número
            value = value.replace(/\D/g, '');

            // Formata como (00) 00000-0000
            if (value.length > 11) {
                value = value.slice(0, 11);
            }

            if (value.length > 6) {
                value = value.replace(/^(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
            } else if (value.length > 2) {
                value = value.replace(/^(\d{2})(\d{0,5})/, '($1) $2');
            } else {
                value = value.replace(/^(\d*)/, '($1');
            }

            e.target.value = value;
        });
    })
}
